/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialListItem
 */
export interface ProviderCredentialListItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderCredentialListItem
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialListItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialListItem
     */
    allowEdit?: boolean;
}

export function ProviderCredentialListItemFromJSON(json: any): ProviderCredentialListItem {
    return ProviderCredentialListItemFromJSONTyped(json, false);
}

export function ProviderCredentialListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function ProviderCredentialListItemToJSON(value?: ProviderCredentialListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'provider': GuidIdAndLabelToJSON(value.provider),
        'enabled': value.enabled,
        'allowEdit': value.allowEdit,
    };
}


